import React, { useState } from "react";
import { Input, message } from "antd";

import CreateBoardFormAutomatedStepThree from "./CreateBoardFormAutomatedStepThree";
import CreateBoardFormAutomatedStepOne from "./CreateBoardFormAutomatedStepOne";
import CreateBoardFormAutomatedStepTwo from "./CreateBoardFormAutomatedStepTwo";
import CreateBoardFormManual from "./CreateBoardFormManual";

import close from "../../assets/icons/close-circle.svg";
import { controller } from "./controller";

export default function CreateBoardForm({ setCreateNewBoard, onBoardCreated }) {
  const [newBoardType, setNewBoardType] = useState("automated"); // Indentifying the tab style based on the board type
  const [automatedStep, setAutomatedStep] = useState("1");
  const [boardName, setBoardName] = useState("");
  const [isCreatingBoard, setIsCreatingBoard] = useState(false);
  const [selectedPatients, setSelectedPatients] = useState([]);
  const [newBoardId, setNewBoardId] = useState(null)
  const [campaignId, setCampaignId] = useState(null)

  async function handleCreateBoard(startDate, endDate) {
    if (!boardName) {
      message.error("Please enter a title name for the board", 3)
    }
    try {
      setIsCreatingBoard(true);

      let newBoardData;
      if (newBoardType === "automated") {
        newBoardData = {
          name: boardName,
          type: newBoardType,
          campaign: {
            statistics: [1, 2, 3, 4
              // { custom_statistics_method: "active_treatment_count" },
              // { custom_statistics_method: "get_active_patient_namest" },
              // { custom_statistics_method: "get_top_procedure_codes_for_patients" },
              // { custom_statistics_method: "get_top_procedure_codes_for_patients_future" }
            ],
            campaign_name: boardName.replaceAll(" ", "_"),
            start_date: startDate,  
            end_date: endDate,
            templates: false,
            organization: [],
            branches: [localStorage.getItem("selectedOffice")],
          },
          office_id: localStorage.getItem("selectedOffice"),
        };
      } else {
        newBoardData = {
          name: boardName,
          type: newBoardType,
          office_id: localStorage.getItem("selectedOffice"),
          patients: selectedPatients.map((patient) => ({ id: patient })),
        };
      }

      // setAutomatedStep("2");
      const response = await controller.createGroup(newBoardData);

      if (response.status === 201) {
        if (newBoardType === "automated") {
          console.log("campId", response.campaign.id)
          setCampaignId(response.campaign.id);

          setAutomatedStep("2");
          setNewBoardId(response.id)
        } else {
          setCreateNewBoard(false);
          message.success("Board created successfully");
        }
      }
    } catch (err) {
      message.error("Something went wrong while creating board");
      console.error(err);
    } finally {
      setIsCreatingBoard(false);
    }
  }

  return (
    <div
      style={{
        width: 400,
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)",
        height: 687,
        minWidth: 376,
        display: "flex",
        flexDirection: "column",
        border: "1px solid #E0DDF7",
        borderRadius: 8,
        padding: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #C9C1F1",
          marginBottom: 20,
          paddingBottom: 15,
        }}
      >
        <p style={{ marginBottom: 0, fontSize: 16, fontWeight: 500 }}>New List</p>

        <img src={close} alt="close" onClick={() => setCreateNewBoard(false)} style={{ cursor: "pointer" }} />
      </div>

      {automatedStep === "1" ? (
        <>
          <p style={{ fontSize: 14 }}>List Name</p>
          <Input
            style={{ borderRadius: 8, border: "1px solid #6B43B5", marginBottom: 20, padding: "10px 15px" }}
            placeholder="Enter Board Name"
            value={boardName}
            onChange={(e) => setBoardName(e.target.value)}
          />

          {/* Custom tabs */}
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 10,
              borderRadius: 100,
              boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)",
              padding: 5,
              marginBottom: 30,
            }}
          >
            <CustomTab current={newBoardType} type="automated" handleClick={() => setNewBoardType("automated")} />
            <CustomTab current={newBoardType} type="manual" handleClick={() => setNewBoardType("manual")} />
          </div>

          {/* Show the form based on tye board type */}
          {newBoardType === "automated" ? (
            <CreateBoardFormAutomatedStepOne boardName={boardName} handleCreateBoard={handleCreateBoard} isCreatingBoard={isCreatingBoard} />
          ) : (
            <CreateBoardFormManual
              setSelectedPatients={setSelectedPatients}
              handleCreateBoard={handleCreateBoard}
              isCreatingBoard={isCreatingBoard}
            />
          )}
        </>
      ) : automatedStep === "2" ? (
        <CreateBoardFormAutomatedStepTwo campaignId={campaignId} boardId={newBoardId} setAutomatedStep={setAutomatedStep} />
      ) : (
        <CreateBoardFormAutomatedStepThree setAutomatedStep={setAutomatedStep} campaignId={campaignId} boardId={newBoardId} setCreateNewBoard={setCreateNewBoard} onBoardCreated={onBoardCreated}/>
      )}
    </div>
  );
}

// Gets both the active tab type (current) and the default tab type (type) to indentify which tab is active.
function CustomTab({ current, type, handleClick }) {
  const tabStyle = current === type ? { backgroundColor: "#6B43B5", color: "white" } : { backgroundColor: "white", color: "#848696" };

  return (
    <div
      onClick={handleClick}
      style={{
        ...tabStyle,
        width: "50%",
        borderRadius: 100,
        padding: "7px 0",
        textAlign: "center",
        textTransform: "capitalize",
        cursor: "pointer",
        transition: "all 0.1s",
      }}
    >
      {type === "automated" ? "automated" : type}
    </div>
  );
}
